<template>
    <v-container fluid>
        <v-row class="pt-2" justify="center" align="center">
            <v-col>
                <h1 class="text-center">Teaching</h1>
            </v-col>
        </v-row>
        <v-row class="pt-6 pb-2" justify="center" align="top">
            <v-col
                v-for="(item,i) in items"
                :key="i"
                cols="10"
                md="6"
            >
                <v-card
                    class="justify-center pt-2 pb-2"
                    color="light-blue darken-4"
                    dark
                    elevated
                >
                    <v-card-title class="justify-center" v-text=item.name></v-card-title>
                    <v-card-subtitle class="text-center" v-text=item.years></v-card-subtitle>
                    <v-card-text>
                        <v-row
                            v-for="(course, j) in item.courses"
                            :key="j"
                            justify="space-around"
                            align="baseline"
                        >
                            <v-col justify="start" align="start">
                                <p v-text=course.classes></p>
                            </v-col>
                            <v-col justify="end" align="end">
                                <p v-text=course.semester></p>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
    
</template>

<script>
export default {
    name: "TeachingDetails",
    data: () => ({
        // comma then create {...} to add another institution
        items: [{
            name: "CSU, Long Beach",
            years: "Teaching Assistant",
            courses: [{
                semester: "Fall 2019",
                classes: "College Algebra"
            }]
        },
        {
            // comma then create {...} to add another semester and classes
            name: "Orange Coast College",
            years: "Teaching Assistant",
            courses: [{
                semester: "Spring 2017-2019",
                classes: "Honors Calculus on Manifolds"
            },{
                semester: "Spring 2016, Summer 2016",
                classes: "Honors Linear Algebra & Differential Equations"
            },{
                semester: "Spring 2016-2017",
                classes: "Discrete Mathematics"
            },{
                semester: "Fall 2015",
                classes: " Honors Calculus 3"
            },
            {
                semester: "Fall 2015",
                classes: " Honors Calculus 1 & 2"
            }]
        }]
    })
};
</script>

<style lang="css" scoped>
.v-card {
    padding-top: 2%;
}
</style>